














































































































































































































































import { Component, Vue, Provide } from "vue-property-decorator";
import { pagnition } from "@/utils/commonConfig";
import { timeFormat, downloadFile } from "@/utils/index";
import { getOrderOptions } from "@/request/ticketClientRequest";
const roleList = () => import("@/components/roleList/index.vue"); //  lee 自己存储的供应商json
interface Phone {
  phoneStart?: String;
  phoneEnd?: String;
  nxtele?: String;
  nxname?: String;
}
enum CompareType {
  COMPARE_TYPE_UNSPECIFIED = 0,
  USER_GROUP = 1, // 角色
  SENIOR_LEADER_USER_GROUP = 2, // 大组长角色
  OM = 3,
}
interface AssignPhoneDialog {
  name?: String;
  email?: String;
  role?: String;
}
@Component({
  name: "performanceComparison.vue",
  components: {
    roleList,
  },
})
export default class PerformanceComparison extends Vue {
  @Provide() private assignStateOptions: any = [
    { value: 1, name: "角色" },
    // { value: 1, name: this.$t('performance.byGroup') },
    // { value: 2, name: this.$t('performance.byStaff') }
    { value: 2, name: "大组" },
    { value: 3, name: "OM" },
  ]; // TicketAssignedGroup int = 1
  // TicketAssignedStaff int = 2
  @Provide() private orderOptions: any = []; // lee 工单分类下拉列表
  @Provide() private totalstats: any = ""; // 各类占比
  @Provide() private labelPosition: string = "right";
  @Provide() private updatedTime: any = ""; // 上次更新时间
  @Provide() private providerOptions: any = [
    {
      id: "1",
      value: "nxtele",
    },
    {
      id: "2",
      value: "infinity",
    },
  ]; // lee 供应商列表
  @Provide() private searchForm: any = {
    UserName: "",
    UserGroup: "",
    ItemId: "",
    CompareType: 1,
    TimeRange: "",
  }; // lee 搜索表单
  @Provide() private pickerOptions: any = {
    shortcuts: [
      {
        text: "Today",
        onClick(picker: any) {
          const start = new Date();
          const _starttime =
            start.getFullYear() + "-" + (start.getMonth() + 1) + "-" + start.getDate();
          start.setTime(new Date(_starttime).getTime());
          const end = new Date();
          end.setTime(end.getTime());
          console.log([start, end]);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "Yesterday",
        onClick(picker: any) {
          const end = new Date();
          const _endtime =
            end.getFullYear() + "-" + (end.getMonth() + 1) + "-" + end.getDate();
          end.setTime(new Date(_endtime).getTime());
          const start = new Date();
          start.setTime(new Date(_endtime).getTime() - 24 * 60 * 60 * 1000);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "Last 7 days",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        },
      },
    ],
  };
  @Provide() private pickDate: any = "";
  @Provide() private multipleSelection: any = []; // lee 多选数组
  @Provide() private resultData: any = [];
  @Provide() private ExtNumber: any = "";
  @Provide() private token: any = "";
  @Provide() private userid: any = "";
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0; // lee 分页参数 目前分页是自己处理的
  @Provide() private pagnition: any = pagnition;
  @Provide() private MorkResultData: any = [
    {
      Id: 1111,
      ExtNumber: 1111,
      Utime: 1111,
      Supplier: 1111,
    },
  ];
  @Provide() private isMorked: boolean = false; // lee 模拟数据
  // @Provide() private isAssignHistory: boolean = false; // lee 是否展示分配历史
  @Provide() private phone: Phone = {
    phoneStart: "",
    phoneEnd: "",
    nxtele: "1",
    nxname: "",
  };
  @Provide() private isDateButton: boolean = false;
  @Provide() private isSearchFormActionDone: boolean = false;
  @Provide() RangeType: number = -1; // 查询规则，小时：1；天：2
  get roleData(): any {
    return this.$store.getters.ROLE_INFO;
  } //  角色
  private created() {
    this.token = localStorage.getItem("token");
    this.userid = localStorage.getItem("userid");
    this.getOrderOptions();
  }
  private mounted() {
    console.log(this.resultData);
    this.$store.commit("SET_ROLE", {
      roleLabel: "角色列表",
    });
  }

  //  lee 获取工单分类下拉列表
  private async getOrderOptions() {
    let res: any = await getOrderOptions({
      token: this.token,
    });
    console.log(res, "rrrrrrrr");
    switch (res.status) {
      case "success":
        this.orderOptions = res.data;
        break;
      case "code":
        this.$router.push("./login");
        break;
      case "error":
        this.$message.error(res.message);
        break;
    }
  }
  private addButton() {
    this.isDateButton = true;
  }
  //   选择类型
  private selectClassify(val: any) {}

  private getBasicTicketAttrs() {}
  //  lee 多選操作
  private handleSelectionChange(val: any) {
    this.multipleSelection = val;
  }
  // lee 搜索操作的判断
  private testSearchForm(): boolean {
    console.log(this.searchForm);
    if (this.searchForm.CompareType !== 3) {
      if (this.searchForm.ItemId) {
        if (this.searchForm.TimeRange && this.searchForm.TimeRange.length > 0) {
          return true;
        } else {
          this.$message.error("Please choose the time");
          return false;
        }
      } else {
        this.$message.error("Please choose the item");
        return false;
      }
    } else {
      if (this.searchForm.TimeRange && this.searchForm.TimeRange.length > 0) {
        return true;
      } else {
        this.$message.error("Please choose the time");
        return false;
      }
    }
  }
  //  lee 搜索操作
  private searchFormAction() {
    if (this.testSearchForm()) {
      this.isSearchFormActionDone = true;
      this.pageIndex = 1;
      this.RangeType = 4;
      this.getExtenList();
    }
  }
  //  lee 清除操作
  private clearFormAction() {
    (this.$refs["searchForm"] as any).resetFields();
    this.searchForm.TimeRange = [];
    console.log(this.searchForm);
  }
  //  lee 清除操作
  private refreshFormAction() {
    if (this.testSearchForm()) {
      this.pageIndex = 1;
      this.getExtenList();
    } else {
      this.$message.warning("Pls enter the right params!!");
    }
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    this.pageIndex = 1;
    //展示表格数据
    this.getExtenList();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getExtenList();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getExtenList();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getExtenList();
  }
  // lee 获取列表
  private dwExtenListFuc() {
    let _arg: any = {
      ItemId: Number(this.searchForm.ItemId), // 工单分类
      Userid: Number(this.searchForm.ItemId), // 用户id
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      Statstype: Number(this.RangeType),
    };
    if (this.searchForm.CompareType) {
      _arg.CompareType = Number(this.searchForm.CompareType);
    }
    switch (this.searchForm.CompareType) {
      case 1:
        if (this.roleData && this.roleData.id) {
          _arg.UserGroupId = this.roleData.id; // 角色
          console.log(this.roleData);
        }
        _arg.UserName = "";
        console.log(_arg);
        break;
      case 2:
        _arg.UserName = ""; // 员工
        _arg.UserGroupId = ""; // 角色
        break;
      case 3:
        _arg.UserName = ""; // 员工
        _arg.UserGroupId = ""; // 角色
        break;
    }
    if (this.searchForm.TimeRange && this.searchForm.TimeRange.length > 0) {
      _arg.Timerange =
        timeFormat(this.searchForm.TimeRange[0].getTime()) +
        " - " +
        timeFormat(this.searchForm.TimeRange[1].getTime());
    }
    return _arg;
  }
  private async getExtenList() {
    let arg = this.dwExtenListFuc();
    const { getRolePerformance }: any = await import("@/request/getRolePerformance");
    let res = await getRolePerformance(arg, this);
    console.log(res, "getRolePerformance");
    if (res) {
      let _result =
        typeof res.listList == "object" ? res.listList : JSON.parse(res.listList);
      this.pagerCount = res.pageout.total;
      this.updatedTime = timeFormat(res.updatetime);
      if(res.totalstats) {
        this.totalstats = res.totalstats;
      }
      if (_result) {
        // lee 接口数据通了，但是没有数据，暂时Mork一份
        this.resultData = this.isMorked ? this.MorkResultData : _result;
        console.log(this.resultData, "getExtenList");
      }
      this.isSearchFormActionDone = res.loading;
    } else {
      this.isSearchFormActionDone = false;
    }
  }
  //  lee 导出操作
  private async exportFormAction() {
    let arg = this.dwExtenListFuc();
    const { getRolePerformanceExcel }: any = await import(
      "@/request/getRolePerformanceExcel"
    );
    let response = await getRolePerformanceExcel(arg, this);
    if (response) {
      console.log(response, response.array[3], "exportFormAction");
      if ((response.array[3] && response, response.array[3].length > 0)) {
        const blob = new Blob([response.array[3]], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        downloadFile(blob, response.array[2]);
      }
    }
  }
  // lee 添加分机号码
  // 没有必传 任意搜哪一个都行
  private testAddExtenPhoneForm(): boolean {
    return true;
  }
  private searchFormActionByTime(num: number) {
    this.RangeType = num;
    this.pageIndex = 1;
    if (this.testSearchForm()) {
      this.getExtenList();
    }
  }
}
